import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  font-size: 18px;
  margin-top: 33px;
`;

export const ButtonWrapper = styled.div`
  float: right;
  display: flex;
  margin-top: 55px;
  & > * + * {
    margin-left: 20px;
  }
  & #cancel_btn {
    background: ${theme.colors.neutral.black6};
    border-color: ${theme.colors.neutral.black6};
    width: 154px;
  }
  & #confirm_btn {
    width: 154px;
  }
`;

export const Text = styled.p`
  font-family: Orkney;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  color: ${theme.colors.neutral.black2};
`;
